let $textSize: any = null;
export const textSize = (text: string) => {
    $textSize = $textSize || document.querySelector('#text-size');
    if (text.includes('&nbsp;')) {
        $textSize.innerHTML = text;
    } else {
        $textSize.innerText = text;
    }
    return parseFloat(window.getComputedStyle($textSize).width);
}           